import { Time } from "ngx-bootstrap/timepicker/timepicker.models";

export class Prospecto {
    idProspecto?: number = -1;
    idUsuario?: number = -1;
    idUsuarioUM?: number = -1;
    idEmpresa?: number = 1;
    idReda?: number = -1;
    idEmpresaAfiliada?: number = -1;
    idSeguimientoProspecto?: number = -1;
    chatSeguimiento?: number = -1;
    interesados?: number = 0;
    pagina?: number = 0;
    cantidadReg?: number = 20;
    //totlProyectos?: Number = -1;
    totalProyectos?: number = -1;
    idProyectoFirst?: number = -1;
    idEmpresaProyectoFirst?: number = -1;
    nombreProyectoFirst?: string = "";
    ultimoMensaje?: string = "";
    idUsuarioUltimoMensaje?: number = -1;
    chatEstatus?: string = "";
    nombre?: string = "";
    presupuesto?: number = 0;
    expectivaCompra?: Date;
    horarioContactoInicio?: Time;
    horarioContactoFin?: Time;
    fechaInicio?: Date;
    fechaFin?: Date;
    fechaRegistroFiltro?: number = -1;
    programacionCanceladaFiltro?: number = -1;
    seguimientoFiltro?: number = -1;
    citaFiltro?: number = -1;
    mesaTrabajoFiltro?: number = -1;
    estrategiaFiltro?: number = -1;
    aceleradorFiltro?: number = -1;
    faceToFaceFiltro?: number = -1;
    procesosCompletados?: number = -1;
    telefono?: string = "";
    lada?: string = "";
    correoElectronico?: string = "";
    descripcion?: string = "";
    idRegion?: number = -1;
    idAsesor?: number = -1;
    idCM?: number = -1;
    idRP?: number = -1;
    idCO?: number = -1;
    idViaProspeccion?: number = -1;
    idsViaProspeccion?: string = "";
    idEncuesta?: number = -1;
    idEvento?: number = -1;
    idCierre?: number = -1;
    fechaCierre?: Date;
    montoCierre?: number = 0;
    comentariosCierre?: string = "";
    estatusCierre?: string = "";
    tipoCaptura?: string = "";
    nombreRP?: string = "";
    telefonoRP?: string = "";
    estatus?: string = "";
    fechaHoraUM?: Date;
    viaProspeccion?: string = "";
    color?: string = "";
    tiempoVida?: Date;
    CantidadMaximaProspectos?: number;
    colorEstatus?: string = "";
    tiempoVidaDias?: number = 0;
    fecha?: Date;
    nombreAsesor?: string = "";
    idAC?: number = 0;
    idsSeguimiento?: string = "";
    idsProyectos?: string = "";
    fechaRegistro?: Date;
    activoNoViable?: number = 0;
    asistioCitaSeguimientoActualnumber?: number = -1;
    perfilamientosNO?: number = -1;
    latitud?: number = 0;
    longitud?: number = 0;
    cexternos?: number = -1;
    avatar?: string = "";
    porcentajeSeguimiento?: number = 0;
    idChat?: number = 0;
    motivoDescarte?: string = "";
    mensajeFiltro?: number = -1;
    idGrupoTelefono?: number = -1;
    checkedMasivo?: boolean = true;
    idCampana?: number = -1;
    nombreEtiqueta?: string = "";
    totalEtiquetas?: number = 0;
    colorEtiqueta?: string = "";
    folio?: number = 0;
}
